import { useContainerInjection } from "../../hooks/useContainerInjection"
import { TournamentMembersViewModel } from "./TournamentMembersViewModel"
import { observer } from "mobx-react"
import TournamentMembersTable from "./components/TournamentMembersTable"
import { Col, Row, Typography } from "antd"
import { useLocation, useNavigate } from "react-router-dom"
import { RoutePaths } from "../../navigation/RoutePaths.enum"
import { useTranslation } from "react-i18next"
import ActivityIndicator from "../../components/ActivityIndicator/ActivityIndicator"
import { colors } from "../../assets/styles/appStyles"
import { Card } from "../../styledComponents/CustomCard/Card"
import { useEffect } from "react"
import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons"
import { Button } from "antd"

const { Title } = Typography

const TournamentMembersView = () => {
	const { t } = useTranslation("tournaments")
	const viewModel = useContainerInjection<TournamentMembersViewModel>("TournamentMembersViewModel")
	const location = useLocation()
	const navigate = useNavigate()
	const tournament = location.state?.service

	useEffect(() => {
		if (tournament?.id) {
			viewModel.fetchTournamentMembers(tournament.id)
		}
	}, [tournament?.id])

	if (!tournament) {
		navigate(RoutePaths.TOURNAMENTS)
		return null
	}

	return (
		<div>
			<div className="tabled">
				<Row gutter={[24, 0]}>
					<Col xs="24" xl={24}>
						<Card
							bordered={false}
							className="criclebox tablespace mb-24"
							title={
								<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
										<Button
											type="text"
											icon={<ArrowLeftOutlined />}
											onClick={() => navigate(RoutePaths.TOURNAMENTS)}
										/>
										<Title style={{ marginTop: 8 }} level={4}>
											{t("members.title")} - {tournament.title}
										</Title>
									</div>
									<div
										style={{
											width: 130,
											height: 40,
											display: "flex",
											justifyContent: "center",
											alignItems: "center"
										}}
									>
										{viewModel.isLoading && (
											<ActivityIndicator size="xxs" color={colors.activity} />
										)}
									</div>
									<Button
										icon={<DownloadOutlined />}
										type="link"
										disabled={viewModel.isDownloading}
										style={viewModel.isDownloading ? { color: colors.activity } : undefined}
										onClick={() => viewModel.downloadTournamentMembers()}
									>
										{t("export")}
									</Button>
								</div>
							}
						>
							<TournamentMembersTable
								data={viewModel.tournamentMembers}
								loading={viewModel.isLoading}
								isFetching={viewModel.isFetching}
							/>
						</Card>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default observer(TournamentMembersView)
